{
  "familyId": "SWW-VD-HULPWW",
  "questions": [
    {
      "id": "SWW-VD-HULPWW-001",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat een voltooid deelwoord?",
      "options": ["Hij heeft gefietst.", "Hij fietst elke dag.", "Hij zal fietsen.", "Hij fietste gisteren."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "VD herkennen", "content": "Een voltooid deelwoord staat samen met een hulpwerkwoord: hebben/zijn + VD. Voorbeeld: heeft gefietst, is gevallen, ben geweest.", "icon": "lightbulb"}}],
      "conceptId": "vd_herkennen_hulpww",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Heeft gefietst' bevat het hulpwerkwoord 'heeft' + het voltooid deelwoord 'gefietst'. Dit is de voltooide tijd. Herken het patroon: hebben/zijn + ge...t/d/en = voltooide tijd.",
        "solutionSteps": [
          "Zoek een hulpwerkwoord: hebben of zijn",
          "Zin A: 'heeft' = hulpwerkwoord ✓",
          "Zoek het voltooid deelwoord: ge...t/d/en → 'gefietst' ✓",
          "Heeft (hulpww) + gefietst (VD) = voltooide tijd ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Heeft gefietst' = hulpwerkwoord + voltooid deelwoord.",
          "1": "Je dacht waarschijnlijk dat 'fietst' een VD is. Maar 'fietst' is de tegenwoordige tijd (hij fietst). Een VD staat altijd bij een hulpwerkwoord. Onthoud: VD = hebben/zijn + ge...t/d/en.",
          "2": "Je dacht waarschijnlijk dat 'fietsen' een VD is. Maar 'zal fietsen' is de toekomende tijd. Het VD zou 'gefietst' zijn. Onthoud: zal + infinitief ≠ VD.",
          "3": "Je dacht waarschijnlijk dat 'fietste' een VD is. Maar 'fietste' is de verleden tijd. Het VD is 'gefietst'. Onthoud: VT = stam + te/de, VD = ge + stam + t/d."
        }
      }
    },
    {
      "id": "SWW-VD-HULPWW-002",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welk hulpwerkwoord hoort bij 'gevallen'? 'De vaas ... gevallen.'",
      "options": ["is", "heeft", "wordt", "zal"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "vallen", "type": "sterk", "forms": { "vt": ["viel", "viel", "viel", "vielen"], "vd": ["gevallen"] }, "hulpww": "zijn", "label": "Bewegingswerkwoord: vallen → is gevallen" }
        }
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hebben of zijn?", "content": "Werkwoorden van beweging of verandering gebruiken 'zijn': is gevallen, is gelopen, is veranderd. Andere werkwoorden gebruiken 'hebben': heeft gefietst, heeft gewerkt.", "icon": "lightbulb"}}],
      "conceptId": "vd_hebben_zijn",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Vallen' is een werkwoord van beweging of verandering van toestand — je gaat van staand naar liggend. Werkwoorden van beweging/verandering gebruiken 'zijn' als hulpwerkwoord: de vaas is gevallen. Check-strategie: zet het in de ik-vorm. Klinkt 'ik ben gevallen' beter dan 'ik heb gevallen'? Ja → gebruik 'zijn'.",
        "solutionSteps": ["Vallen = beweging/verandering", "Beweging/verandering → hulpwerkwoord 'zijn'", "Check: 'ik ben gevallen' klinkt goed ✓", "De vaas is gevallen"],
        "distractorExplanations": {
          "0": "Goed! Vallen = beweging → is gevallen.",
          "1": "'Heeft gevallen' klinkt misschien logisch, maar 'vallen' is een bewegingswerkwoord. Check: 'ik ben gevallen' klinkt beter dan 'ik heb gevallen'. Beweging/verandering → altijd 'zijn'.",
          "2": "'Wordt' gebruik je bij de lijdende vorm (bijv. 'het boek wordt gelezen'). Bij de voltooide tijd gebruik je 'hebben' of 'zijn' + VD. Vallen = beweging → is gevallen.",
          "3": "'Zal' hoort bij de toekomende tijd + infinitief: 'zal vallen'. Bij de voltooide tijd gebruik je 'hebben' of 'zijn' + VD: is gevallen."
        }
      }
    },
    {
      "id": "SWW-VD-HULPWW-003",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "options": ["Wij hebben hard gewerkt.", "Wij zijn hard gewerkt.", "Wij hadden hard gewerken.", "Wij hebben hard werkte."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "werken", "type": "zwak", "forms": { "vt": ["werkte", "werkte", "werkte", "werkten"], "vd": ["gewerkt"] }, "hulpww": "hebben", "label": "Geen beweging: werken → heeft gewerkt" }
        }
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Voltooide tijd", "content": "Voltooide tijd = hulpwerkwoord (hebben/zijn) + voltooid deelwoord. Werken → gewerkt. 'Werken' is geen bewegingswerkwoord, dus: hebben gewerkt.", "icon": "lightbulb"}}],
      "conceptId": "vd_correcte_constructie",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Werken' is geen werkwoord van beweging of verandering — je blijft op dezelfde plek. Daarom gebruik je 'hebben': wij hebben hard gewerkt. Het VD van 'werken' maak je met ge + stam + t: ge-werk-t = gewerkt. Check-strategie: zet het in de ik-vorm. 'Ik heb gewerkt' klinkt beter dan 'ik ben gewerkt' → gebruik 'hebben'.",
        "solutionSteps": ["Werken = geen beweging/verandering → 'hebben'", "VD van werken: ge + werk + t = gewerkt", "Check: 'ik heb gewerkt' klinkt goed ✓", "Wij hebben hard gewerkt"],
        "distractorExplanations": {
          "0": "Goed! Hebben + gewerkt is correct. Werken is geen bewegingswerkwoord.",
          "1": "'Zijn gewerkt' klinkt niet goed. 'Werken' is geen bewegingswerkwoord, dus gebruik je 'hebben'. Check: 'ik heb gewerkt' klinkt beter dan 'ik ben gewerkt'.",
          "2": "'Gewerken' bestaat niet als woordvorm in het Nederlands. Het VD maak je met ge + stam + t/d: ge-werk-t = gewerkt. De infinitief ('werken') gebruik je niet na een hulpwerkwoord in de voltooide tijd.",
          "3": "'Werkte' is de verleden tijd (VT), niet het voltooid deelwoord (VD). Na 'hebben' hoort het VD: gewerkt. Onthoud: VT = stam + te/de, VD = ge + stam + t/d."
        }
      }
    },
    {
      "id": "SWW-VD-HULPWW-004",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord gebruikt 'zijn' als hulpwerkwoord in de voltooide tijd?",
      "options": ["vertrekken (is vertrokken)", "eten (heeft gegeten)", "lezen (heeft gelezen)", "slapen (heeft geslapen)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "vertrekken", "type": "sterk", "forms": { "vt": ["vertrok", "vertrok", "vertrok", "vertrokken"], "vd": ["vertrokken"] }, "hulpww": "zijn", "label": "Bewegingswerkwoord: vertrekken → is vertrokken" }
        }
      ],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Zijn als hulpwerkwoord", "content": "Werkwoorden van beweging of verandering van toestand gebruiken 'zijn': vertrekken, komen, gaan, vallen, groeien, sterven. Andere werkwoorden gebruiken 'hebben'.", "icon": "lightbulb"}}],
      "conceptId": "vd_zijn_werkwoorden",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Vertrekken' is een werkwoord van beweging (je gaat ergens weg). Daarom: is vertrokken. De andere werkwoorden (eten, lezen, slapen) gebruiken 'hebben' omdat ze geen beweging of verandering van toestand beschrijven. Zet om naar de ik-vorm: ik ben vertrokken ✓.",
        "solutionSteps": ["Vertrekken = beweging → zijn", "Is vertrokken ✓", "Eten, lezen, slapen = geen beweging → hebben", "Check: ik ben vertrokken ✓"],
        "distractorExplanations": {
          "0": "Goed! Vertrekken = beweging → is vertrokken.",
          "1": "Je dacht waarschijnlijk dat 'eten' een bewegingswerkwoord is. Maar eten is geen beweging of verandering. Onthoud: je zegt 'heeft gegeten', niet 'is gegeten'.",
          "2": "Je dacht waarschijnlijk dat 'lezen' een bewegingswerkwoord is. Maar lezen is geen beweging of verandering. Onthoud: je zegt 'heeft gelezen', niet 'is gelezen'.",
          "3": "Je dacht waarschijnlijk dat 'slapen' een bewegingswerkwoord is. Maar slapen is geen beweging of verandering. Onthoud: je zegt 'heeft geslapen', niet 'is geslapen'."
        }
      }
    },
    {
      "id": "SWW-VD-HULPWW-005",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul het juiste hulpwerkwoord in: De trein ... al vertrokken. (hebben of zijn)",
      "options": [],
      "correctAnswer": "is",
      "data": {
        "acceptedAnswers": ["is"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Vertrekken → zijn", "content": "Vertrekken is een werkwoord van beweging. Daarom gebruik je 'zijn': de trein is vertrokken.", "icon": "lightbulb"}}],
      "conceptId": "vd_hulpww_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vertrekken' is een werkwoord van beweging — de trein gaat ergens weg. Werkwoorden van beweging of verandering van toestand gebruiken 'zijn' als hulpwerkwoord: de trein is al vertrokken. Check-strategie: klinkt 'de trein is vertrokken' beter dan 'de trein heeft vertrokken'? Ja → gebruik 'zijn'.",
        "solutionSteps": [
          "Welk werkwoord? Vertrekken",
          "Vertrekken = beweging (ergens weggaan)",
          "Beweging → hulpwerkwoord 'zijn'",
          "De trein is al vertrokken ✓"
        ]
      }
    },
    {
      "id": "SWW-VD-HULPWW-006",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "categorize",
      "question": "Sorteer deze werkwoorden: gebruiken ze 'hebben' of 'zijn' als hulpwerkwoord in de voltooide tijd?",
      "correctAnswer": null,
      "data": {
        "categories": ["hebben", "zijn"],
        "items": [
          { "text": "fietsen (hij is gefietst)", "correctCategory": 1 },
          { "text": "werken (hij heeft gewerkt)", "correctCategory": 0 },
          { "text": "vallen (hij is gevallen)", "correctCategory": 1 },
          { "text": "koken (hij heeft gekookt)", "correctCategory": 0 },
          { "text": "vertrekken (hij is vertrokken)", "correctCategory": 1 },
          { "text": "lezen (hij heeft gelezen)", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hebben of zijn?", "content": "Zijn: bij werkwoorden van beweging (fietsen, vallen, vertrekken) of verandering van toestand (groeien, sterven). Hebben: bij alle andere werkwoorden (werken, koken, lezen).", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_hulpww_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De keuze tussen 'hebben' en 'zijn' hangt af van het type werkwoord. Werkwoorden van beweging van A naar B (fietsen, vertrekken) of verandering van toestand (vallen) gebruiken 'zijn'. Alle andere werkwoorden (werken, koken, lezen) gebruiken 'hebben'. Checkstrategie: zeg hardop 'ik ben ge...' en 'ik heb ge...' — welke klinkt natuurlijker? 'Ik ben gefietst' ✓ vs. 'ik heb gefietst' ✗.",
        "solutionSteps": [
          "Stap 1: Bepaal het type werkwoord — gaat het om beweging (van A naar B) of verandering van toestand?",
          "Fietsen = beweging → zijn. Vallen = verandering van toestand → zijn. Vertrekken = beweging → zijn.",
          "Werken, koken, lezen = geen beweging of verandering → hebben.",
          "Checkstrategie: zeg hardop 'ik ben gevallen' (klinkt goed ✓) vs. 'ik heb gevallen' (klinkt fout ✗)"
        ]
      }
    },
    {
      "id": "SWW-VD-HULPWW-007",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul het juiste hulpwerkwoord in: De kat ... van het dak gevallen. (hebben of zijn?)",
      "correctAnswer": "is",
      "data": {
        "acceptedAnswers": ["is"],
        "placeholder": "hebben of zijn?",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hebben of zijn?", "content": "Vallen = beweging → hulpwerkwoord 'zijn'. De kat is gevallen.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_hulpww_fill_in_zijn",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vallen' beschrijft een verandering van toestand en positie — iets gaat van boven naar beneden. Werkwoorden die een verandering van toestand of beweging van A naar B beschrijven, gebruiken 'zijn' als hulpwerkwoord. Checkstrategie: vervang het onderwerp door 'ik' en zeg het hardop: 'ik ben gevallen' klinkt goed ✓, 'ik heb gevallen' klinkt fout ✗. Dus: de kat is gevallen.",
        "solutionSteps": [
          "Stap 1: Welk werkwoord? → vallen",
          "Stap 2: Wat voor type? → verandering van toestand (van boven naar beneden)",
          "Stap 3: Verandering/beweging → hulpwerkwoord 'zijn'",
          "Stap 4: Check — zeg hardop: 'ik ben gevallen' ✓ (klinkt goed)",
          "Antwoord: de kat is van het dak gevallen"
        ]
      }
    },
    {
      "id": "SWW-VD-HULPWW-008",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "matching",
      "question": "Koppel elk werkwoord aan het juiste hulpwerkwoord in de voltooide tijd.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "groeien", "right": "is gegroeid" },
          { "left": "koken", "right": "heeft gekookt" },
          { "left": "vertrekken", "right": "is vertrokken" },
          { "left": "lezen", "right": "heeft gelezen" },
          { "left": "vallen", "right": "is gevallen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hebben of zijn?",
            "content": "Werkwoorden van beweging of verandering van toestand → 'zijn' (groeien, vertrekken, vallen). Andere werkwoorden → 'hebben' (koken, lezen). Check: klinkt 'ik ben ...' of 'ik heb ...' beter?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_hulpww_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Groeien = verandering van toestand → is gegroeid. Koken = geen beweging → heeft gekookt. Vertrekken = beweging → is vertrokken. Lezen = geen beweging → heeft gelezen. Vallen = beweging → is gevallen.",
        "solutionSteps": [
          "Vraag per werkwoord: is het beweging of verandering van toestand?",
          "Ja → 'zijn': groeien (is gegroeid), vertrekken (is vertrokken), vallen (is gevallen)",
          "Nee → 'hebben': koken (heeft gekookt), lezen (heeft gelezen)",
          "Check: 'ik ben gevallen' klinkt goed ✓, 'ik heb gekookt' klinkt goed ✓"
        ]
      }
    },
    {
      "id": "SWW-VD-HULPWW-009",
      "familyId": "SWW-VD-HULPWW",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_hulpwerkwoorden",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg 'vertrekken' naar het voltooid deelwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "vertrekken",
        "targetForm": "voltooid deelwoord",
        "context": "De trein ... al ... (vertrekken)",
        "finalAnswer": "is vertrokken",
        "steps": [
          {
            "id": "step1",
            "prompt": "Hebben of zijn?",
            "type": "choice",
            "options": [
              { "label": "hebben", "value": "hebben", "isCorrect": false, "feedback": "Vertrekken is een beweging → gebruik 'zijn'." },
              { "label": "zijn", "value": "zijn", "isCorrect": true }
            ]
          },
          {
            "id": "step2",
            "prompt": "Vul in: De trein ... al ...",
            "type": "input",
            "acceptedAnswers": ["is vertrokken"]
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hebben of zijn?",
            "content": "Werkwoorden van beweging (vertrekken, vallen, lopen) gebruiken 'zijn'. Dus: is vertrokken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vd_hulpww_flow",
      "variantIndex": 9,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Vertrekken is een werkwoord van beweging → hulpwerkwoord 'zijn'. Het voltooid deelwoord is 'vertrokken'. Samen: is vertrokken.",
        "solutionSteps": [
          "Vertrekken = beweging → 'zijn'",
          "VD = vertrokken → is vertrokken"
        ]
      }
    }
  ]
}